export const activeHeroesSelector = state => state.mostActiveHeroes.get('activeHeroes');

export const isLoadingSelector = state => state.mostActiveHeroes.get('isLoading');
